import { partnerClient } from '@modules/core/services';
import { DEFAULT_STUDY_ID } from '../constants';
import {
  CDCTier1ResultsBreakdownParams,
  CDCTier1ResultsBreakdownResponse,
} from '../types/cdc-tier-1-results-breakdown.types';

export const fetchCDCTier1ResultsBreakdown = async ({
  startDate,
  endDate,
  studyId = DEFAULT_STUDY_ID,
}: CDCTier1ResultsBreakdownParams): Promise<CDCTier1ResultsBreakdownResponse | undefined> => {
  const data = await partnerClient.get(`/studies/${studyId}/metrics/cdc-tier1-results`, {
    params: {
      startDate,
      endDate,
    },
  });

  return data?.data;
};
